import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../provider/AppContext";

// Returns openContractTab(contract): shows the contract in a tab on /contracts,
// adding the tab first if it is not open yet.
export const useOpenContractTab = () => {
  const {
    contractTab,
    setContractTabs,
    summary,
    setSummaryArray,
    summaryRef,
    setTabRef,
  } = useContext(AppContext);
  const navigate = useNavigate();

  return (contract) => {
    const openIndex = (contractTab || []).findIndex(
      ({ id }) => id === contract?.id
    );
    // Tab 0 is the Contracts table, so contract tabs start at 1
    let tabIndex = openIndex + 1;
    if (openIndex < 0) {
      const summaryDetails = [...(summary || []), contract];
      if (summaryRef) {
        summaryRef.current = summaryDetails;
      }
      setSummaryArray(summaryDetails);
      const tabs = [...(contractTab || []), contract];
      setContractTabs(tabs);
      tabIndex = tabs.length;
    }
    navigate("/contracts");
    // TabsPanel mounts on /contracts; select the tab once it has
    setTimeout(() => setTabRef?.current?.(tabIndex), 100);
  };
};
